<template>
  <v-dialog v-model="dialog" persistent hide-overlay max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{alterar}} Cliente</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field :rules="nomeRules" v-model="cliente.nome" label="Nome" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="telRules"
                v-model="cliente.telefone"
                hint="Utilizar somente números ex:3199999999"
                persistent-hint
                label="Telefone"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Cpf"
                mask="###########"
                :rules="cpfRules"
                counter="11"
                v-model="cliente.cpf"
                hint="utiliza somente números"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="cliente.email"
                :rules="emailRules"
                name="email"
                label="Email"
                value
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="170"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  outline
                  slot="activator"
                  v-model="dataFimFormatted"
                  label="Data Nascimento"
                  readonly
                  persistent-hint
                  prepend-icon="event"
                  required
                  clearable
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  locale="pt-br"
                  v-model="dataFim"
                  no-title
                  @change="save"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1930-01-01"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Campos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" color="terciary" @click.native="parente()">Cancelar</v-btn>
        <v-btn
          :loading="loadingBtn"
          :disabled="loadingBtn"
          class="white--text"
          color="sucesso"
          @click.native="salvar();loadingBtn=true;loader = 'loadingBtn'"
        >Gravar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";

var moment = require("moment");

export default {
  name: "FormCadCliente",
  props: ["dialog"],
  mixins: [formata],

  data: () => ({
    loader: null,
    loadingBtn: false,
    cliente: {
      nome: "",
      cpf: "",
      email: "",
      telefone: "",
      data_nascimento: "",
      cnpj_origem: window.sessionStorage.getItem("cnpj")
    },
    menu: false,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: "",
    alterar: "",
    nomeRules: [v => !!v || "Nome é requerido"],
    telRules: [v => !!v || "Telefone é requerido"],
    emailRules: [v => !!v || "email é requerido"],
    cpfRules: [
      v => !!v || "Cpf é requerido",
      v => v.length == 11 || "Cpf   Menor que o padrão"
    ]
  }),
  mounted() {
    //alert(this.dados);
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dataFimFormatted(val) {
      if (val == null) {
        this.cliente.data_nascimento = "";
      }
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    /*dados(val) {
      if (val) {
        this.convenio.nome = val.nome;
        this.convenio.cnpj = val.cnpj;
        this.convenio.descricao = val.descricao;
        this.convenio.id = val.id;
        this.alterar = "Alterar ";
      } else {
        this.convenio.id = "";
        this.alterar = "";
      }
    },*/
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    save(data) {
      console.log(data);
      this.cliente.data_nascimento = this.parseDate(this.dataFimFormatted);
    },
    getErroCadCliente(texto) {
      this.textSnack = texto;
      this.snackbar = true;
    },

    salvar() {
      HTTP.post(`cliente/precadastro_retaguarda`, this.cliente)
        .then(response => {
          if (response.data.error) {
            alert("erros:");
          }
          this.cliente.cpf = "";
          this.cliente.nome = "";
          this.cliente.email = "";
          this.cliente.telefone = "";
          this.cliente.data_nascimento = "";
          this.loader = null;
          this.loadingBtn = false;
          this.$emit("gravacaoOkCliente");
          this.$emit("fechaDialog");
          this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          console.log(e.response.data.error);
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.loadingBtn = false;
            this.$emit("getCadCliente", itens.join(","));
          }
        });
      // this.$parent.selDialog = false;
    },
    parente() {
      this.$emit("fechaDialog");
    },

    checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar() {
      // this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaConvenios() {
      this.loading = true;
      HTTP.get(`grupo/lista/convenio`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =

          this.items = response.data;
          this.mostraCartoes = true;
        }
        this.loading = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormCadCliente.vue